export default __webpack_public_path__ + "static/media/mobilepreview.4b6aca90.svg";